import React from 'react';
import { Link } from 'react-router-dom';
import { ACHIEVEMENTS, SITE } from '../../mock';

export default function Achievements() {
  // Map 6 cards each to an image/visual treatment
  const visuals = [
    { kind: 'badge', label: 'QSF\u2122', accent: 'from-amber-200 to-amber-500' },
    { kind: 'numeric', big: '7', sub: 'Subconscious Shifts' },
    { kind: 'numeric', big: '1:1', sub: 'Private Sessions' },
    { kind: 'image', src: SITE.bookCover, alt: 'You Are The Magician book cover' },
    { kind: 'pillars', items: ['Astrology', 'Vastu', 'Numerology', 'Psychology'] },
    { kind: 'badge', label: 'WORLD\nNo. 1', accent: 'from-amber-100 to-amber-400' },
  ];

  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {ACHIEVEMENTS.map((a, i) => (
          <article
            key={a.title}
            className="group relative overflow-hidden rounded-3xl border border-white/10 bg-navy-900/50 p-6 md:p-8 transition-all duration-300 hover:border-amber-300/30 hover:-translate-y-[2px]"
          >
            <div className="relative aspect-[16/10] rounded-2xl overflow-hidden bg-navy-950 border border-white/5">
              <Visual v={visuals[i]} />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-transparent to-transparent" />
            </div>
            <div className="mt-6">
              <p className="text-[11px] tracking-[0.22em] uppercase text-amber-300/80">
                {a.tag}
              </p>
              <h3 className="mt-2 font-serif text-white text-[24px] md:text-[28px] leading-tight tracking-tight">
                {a.title}
              </h3>
              <p className="mt-3 text-neutral-400 text-[14px] md:text-[15px] leading-relaxed">
                {a.desc}
              </p>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-16 flex justify-center">
        <Link
          to="/apply"
          className="inline-flex items-center justify-center rounded-full px-7 py-3.5 text-[15px] font-medium text-navy-900 bg-gradient-to-b from-amber-200 to-amber-400 shadow-[0_8px_30px_-6px_rgba(251,191,36,0.5)] hover:-translate-y-[2px] hover:shadow-[0_14px_40px_-6px_rgba(251,191,36,0.7)] transition-all"
        >
          Apply to Work With Us
        </Link>
      </div>
    </section>
  );
}

function Visual({ v }) {
  if (!v) return null;
  if (v.kind === 'image') {
    return (
      <img
        src={v.src}
        alt={v.alt}
        className="w-full h-full object-cover"
        loading="lazy"
      />
    );
  }
  if (v.kind === 'badge') {
    return (
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(251,191,36,0.18),transparent_60%)]" />
        <div className={`relative font-serif text-transparent bg-clip-text bg-gradient-to-b ${v.accent} text-[64px] md:text-[88px] leading-[0.95] text-center whitespace-pre-line tracking-tight`}>
          {v.label}
        </div>
      </div>
    );
  }
  if (v.kind === 'numeric') {
    return (
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-serif text-white text-[120px] md:text-[140px] leading-none">
          {v.big}
        </div>
        <p className="mt-2 text-amber-300/90 text-xs tracking-[0.25em] uppercase">
          {v.sub}
        </p>
      </div>
    );
  }
  if (v.kind === 'pillars') {
    return (
      <div className="absolute inset-0 grid grid-cols-2 gap-3 p-6">
        {v.items.map((it) => (
          <div
            key={it}
            className="rounded-xl border border-amber-300/15 bg-amber-300/[0.04] flex items-center justify-center text-amber-200/90 text-sm tracking-[0.15em] uppercase"
          >
            {it}
          </div>
        ))}
      </div>
    );
  }
  return null;
}
